export default {
    assessment_score_1: "",
    assessment_score_2: "",
    assessment_score_3: "",
    assessment_score_4: "",
    assessment_score_5: "",
    assessment_score_6: "",
};
